import {
    getDimensionsFromSvg,
    readFileAsString,
} from '../../illustrations/utils/illustrationTransformationUtils';

const ICON_NAME_REGEX = /[^a-z_]|^ic_|_ic_|^ic/g;

export function validTileLogoName(tileLogoName) {
    return tileLogoName && !tileLogoName.match(ICON_NAME_REGEX);
}

export function getTileLogoNameError(tileLogoName) {
    if (!tileLogoName) {
        return 'Tile Logo name cannot be empty';
    }

    if (tileLogoName.match(/[A-Z]/g)) {
        return 'Uppercase characters not allowed';
    }

    if (tileLogoName.match(/[\d]/g)) {
        return 'Numeric characters not allowed';
    }

    if (tileLogoName.match(/[^a-z_]/g)) {
        return 'Special characters except _ not allowed';
    }
}

export async function validTileLogoFileSize(tileLogoFile) {
    const iconSize = 40;
    // If icon is null return false
    if (!tileLogoFile) {
        return false;
    }

    // Read the icon file as a string
    const fileAsString = await readFileAsString(tileLogoFile);
    // Get dimensions of the icon file
    var dimensions = getDimensionsFromSvg(fileAsString);
    console.log(typeof dimensions.width);
    // If dimenstions are not equal to icon size, return false
    return dimensions.width === iconSize && dimensions.height === iconSize
}
